import type { License } from "@/pages/licenses/hooks/useMyLicenses";
import { formatFullDate } from "@/lib/format";
import { LICENSE_STATUS_META, editionLabel } from "@/lib/license";

function sanitizeFileName(input: string): string {
  const cleaned = input
    .replace(/[\\/:*?"<>|\s]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();
  return cleaned || "license";
}

export function buildLicenseFileContent(license: License): string {
  const status = LICENSE_STATUS_META[license.status]?.label ?? license.status;
  const lines = [
    "========================================",
    "         LicenseHub 许可证文件",
    "========================================",
    `产品名称   : ${license.product_name}`,
    `版本类型   : ${editionLabel(license.edition)}`,
    `许可证密钥 : ${license.license_key}`,
    `授权席位   : ${license.seat_count}`,
    `最大激活数 : ${license.max_activations}`,
    `签发日期   : ${license.issued_at ? formatFullDate(license.issued_at) : "--"}`,
    `到期日期   : ${license.expires_at ? formatFullDate(license.expires_at) : "永久"}`,
    `当前状态   : ${status}`,
    "----------------------------------------",
    `生成时间   : ${formatFullDate(new Date())}`,
    "",
    "该文件由 LicenseHub 自动生成，请妥善保管，",
    "请勿在公开渠道分享或泄露其中的密钥信息。",
    "",
  ];
  return lines.join("\n");
}

export function downloadLicenseFile(license: License): string {
  const content = buildLicenseFileContent(license);
  const fileName = `${sanitizeFileName(license.product_name)}-${license.license_key.slice(-8)}.lic`;
  const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
  return fileName;
}